export const TKeyCompetition = {
  COMPETITION_NAV: "COMPETITION_NAV",
} as const;
